import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginAdmin, registerUser, logoutUser } from '../../api/request';
import './loginPage.css';

export default function LoginPage({ onLogin }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [isLogin, setIsLogin] = useState(true);

  const [form, setForm] = useState({ email: '', password: '', username: '', fullName: '' });

  const [message, setMessage] = useState('');

  const [error, setError] = useState('');

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsLoggedIn(document.cookie.includes('jwt='));
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/');
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (location.state?.isRegister) {
      setIsLogin(false);
    }
  }, [location.state]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const toggleForm = () => {
    setIsLogin(!isLogin);
    setForm({ email: '', password: '', username: '', fullName: '' });
    setMessage('');
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      if (isLogin) {
        const data = await loginAdmin({ email: form.email, password: form.password });
        document.cookie = `jwt=${data.token}; path=/;`;
        setMessage('Logged in successfully!');
        setIsLoggedIn(true);
        if (onLogin) onLogin(data.token);
        navigate('/');
      } else {
        await registerUser({
          email: form.email,
          password: form.password,
          username: form.username,
          fullName: form.fullName,
        });
        setMessage('Account created! You can now log in.');
        setIsLogin(true);
        setForm({ email: '', password: '', username: '', fullName: '' });
      }
    } catch (err) {
      setError(err.message || 'Something went wrong');
    }
  };

  const handleLogout = async () => {
    try {
      await logoutUser();
      document.cookie = 'jwt=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
      setIsLoggedIn(false);
      window.location.href = "/login";
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-container">
        {!isLoggedIn ? (
          <>
            <h2>{isLogin ? 'Login' : 'Register'}</h2>
            <form onSubmit={handleSubmit} className="login-form">
              {!isLogin && (
                <>
                  <input
                    type="text"
                    name="username"
                    placeholder="Username"
                    value={form.username}
                    onChange={handleChange}
                    required
                    className="input-field"
                  />
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={form.fullName}
                    onChange={handleChange}
                    required
                    className="input-field"
                  />
                </>
              )}
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
                required
                className="input-field"
              />
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={form.password}
                onChange={handleChange}
                required
                className="input-field"
              />
              <button type="submit" className="submit-button">
                {isLogin ? 'Login' : 'Create Account'}
              </button>
            </form>

            {message && <p className="message success-message">{message}</p>}
            {error && <p className="message error-message">{error}</p>}

            <p className="toggle-text" onClick={toggleForm}>
              {isLogin
                ? "Don't have an account? Register here."
                : 'Already have an account? Login here.'}
            </p>
          </>
        ) : (
          <>
            <h2>You are logged in</h2>
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </>
        )}
      </div>
    </div>
  );
}
